//@ts-ignore
// @ts-nocheck
import { types } from "mobx-state-tree";

const LessonPaymentStore = types
  .model("LessonPaymentStore", {
    students: types.optional(types.number, 0),
    lessons: types.optional(types.number, 0),
    lessonRate: types.optional(types.number, 0),
    lessonFee: types.optional(types.number, 0),
    perStudentFee: types.optional(types.number, 0),
    extraStudent: types.optional(types.number, 0),
    firstBookingDiscount: types.optional(types.number, 0),
    name: types.optional(types.string, ""),
    distance: types.optional(types.number, 0),
    transportFare: types.optional(types.number, 0),
  })
  .views((self) => {
    return {
      get tutorEarnings() {
        return self.lessonFee;
      },
      get priceIsFetched() {
        return true;
      },
      get currency() {
        return "₦";
      },
    };
  });

export default LessonPaymentStore;
